import { CdkDragDrop, DropListOrientation, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, Input, OnInit } from "@angular/core";
import { QuestionEnumValue } from "src/app/main/model/forms/question-list.model";
import { QuestionRank } from "src/app/main/model/forms/question-rank.model";
import { FormCompletionBaseComponent } from "../form-completion-base.component";

@Component({
  selector: "app-question-rank",
  templateUrl: "./question-rank.component.html",
  styleUrls: ["./question-rank.component.scss"],
  standalone: false,
})
export class QuestionRankComponent extends FormCompletionBaseComponent implements OnInit {
  @Input() public question: QuestionRank;

  public rankedOptions: QuestionEnumValue[] = [];

  ngOnInit() {
    const enumValues = this.question.questionEnum.enumValues;
    const savedValue = this.control.value;

    if (Array.isArray(savedValue) && savedValue.length) {
      const ordered: QuestionEnumValue[] = [];
      const seen = new Set<string | number>();
      for (var i = 0; i < savedValue.length; i++) {
        const saved = savedValue[i];
        const match = enumValues.find((ev) => ev.value === saved.value);
        if (match && !seen.has(match.value)) {
          ordered.push(match);
          seen.add(match.value);
        }
      }
      for (var i = 0; i < enumValues.length; i++) {
        const ev = enumValues[i];
        if (!seen.has(ev.value)) {
          ordered.push(ev);
        }
      }
      this.rankedOptions = ordered;
    } else {
      // Preserve the order the backend already applied (the questionnaire-specific display order,
      // or the source order by default). Re-sorting by `order` here would undo a per-questionnaire
      // reorder saved on FormTemplateQuestion.viewMeta.optionOrder.
      this.rankedOptions = [...enumValues];
    }
  }

  public onDrop(event: CdkDragDrop<QuestionEnumValue[]>): void {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.rankedOptions, event.previousIndex, event.currentIndex);
    }
    this._syncControl();
  }

  /**
   * Explicitly confirms the currently displayed ranking without requiring a reorder.
   */
  public confirmRanking(): void {
    this._syncControl();
  }

  public get isConfirmed(): boolean {
    return Array.isArray(this.control.value) && this.control.value.length > 0;
  }

  /**
   * Writes the displayed ranking only after a deliberate reorder or confirmation.
   */
  private _syncControl(): void {
    if (!this.service) {
      return;
    }
    this.recordExplicitAnswer(
      this.question,
      this.rankedOptions.map((ev) => ({ value: ev.value, isMultiple: true }))
    );
  }

  public get control() {
    return this.service.formGroup.controls[this.question.getName()];
  }

  public get orientation(): DropListOrientation {
    return this.question.getContentDirection() as DropListOrientation;
  }
}
